import { Module, MutationTree, ActionTree, GetterTree } from 'vuex'
import { RootState } from '@/types/store/index'
import { UserState } from '@/types/store/user'
import { UserAttributes } from '@/types/models/user'
import { axios, ApiResponse } from '@/plugins/axios'
import { SelectOptions } from '@/types/forms/select'
import { changeDocumentTitle } from '@/utils/document'
import { TAILWIND_BG_COLORS } from '@/utils/tailwind'

const initialValues: UserState = {
  user: undefined,
  prefList: [],
  color: undefined
}

const state = (): UserState => (initialValues)

const getters: GetterTree<UserState, RootState> = {
}

const mutations: MutationTree<UserState> = {
  setUser (state, user?: UserAttributes) {
    state.user = user
  },
  setPrefList (state, prefList: SelectOptions = []) {
    state.prefList = prefList
  },
  setColor (state) {
    if (! state.user) {
      state.color = TAILWIND_BG_COLORS[Math.floor(Math.random() * TAILWIND_BG_COLORS.length)]
    }
  }
}

const actions: ActionTree<UserState, RootState> = {
  fetchUser: async ({ commit }) => {
    commit('setColor')
    await new Promise<void>((resolve, reject) => {
      axios.get<ApiResponse<UserAttributes>>('/account/user')
        .then(response => {
          commit('setUser', response.data.payload)
          changeDocumentTitle()
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  fetchPrefList: async ({ state, commit }) =>{
    if (! state.prefList.length) {
      const response = await axios.get('/account/pref-list')
      commit('setPrefList', response.data.payload)
    }
  },
}

export const user: Module<UserState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
